<template>
    <div>
        <h2>{{ $t("invoice.control_properties") }}</h2>
        <div class="box">
            <p>{{ $t("invoice.control_properties_texte") }}</p>
            <DateRangeV2
                v-if="start_date && end_date"
                :start.sync="start_date"
                :end.sync="end_date"
                @submit="init_component"
                :dateSelect="true"
                :periodToShow="[ 'personalise', 'mois_dernier', 'mois']"
                periodLabel="mois"
            />

            <CustomTable
                id_table="control_properties"
                :items="properties"
                :busy.sync="table_busy"
                primaryKey="horse_id"
                :hide_if_empty="true"
                :hrefsRoutes="config_table_hrefs"
            />
        </div>
    </div>
</template>


<script type="text/javascript">
    import Invoice from "@/mixins/Invoice.js"

    export default {
        name: "controlProperties",
        mixins: [Invoice],
        data () {
            return {
                start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                end_date: new Date(),
                properties: [],
                table_busy: true,
                config_table_hrefs: {
                    'horse_nom': {
                        routeUniqueName: 'horseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                }
            }
        },
        methods: {
            async init_component() {
                this.table_busy = true
                const properties = await this.controlProperties(this.start_date.toDateInputValue(), this.end_date.toDateInputValue())
                this.properties = properties.actes.concat(properties.pension)
                this.table_busy = false
            }
        },
        components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2')
        }
    }
</script>
